export const TaskStatus = {
    New: 1,
    InProgress: 2,
    Completed: 3,
    InCompleted: 4,

    get(status) {
        return this.all().find(x => x.value === status);
    },
    all() {
        return [
            {value: TaskStatus.New, translationKey: 'task.status.new'},
            {value: TaskStatus.InProgress, translationKey: 'task.status.inProgress'},
            {value: TaskStatus.Completed, translationKey: 'task.status.completed'},
            {value: TaskStatus.InCompleted, translationKey: 'task.status.inCompleted'},
        ];
    }
};